/**
 * @desc undefined
 */
import { AuctionPlanEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAuctionPlanParameter = {
  id?: string
}

const method = 'GET'
const url = '/trade/plan'

export const queryAuctionPlanApi = (
  params?: QueryAuctionPlanParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AuctionPlanEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryAuctionPlanApi.method = method
queryAuctionPlanApi.url = url
